import styled from 'styled-components';

export default styled.div`
  padding: ${props => props.padding};
  border: solid 1px ${props => props.theme.primaryColor};
  border-radius: 4px;
  background: ${props => props.bg || '#fff'};
`;
